import { PersonPropertyValue } from 'api/clients/PropertyClient'
import Styles from '../PropertyValue.module.scss'
import Person from './Person'

interface Props {
  propertyValues: PersonPropertyValue[]
  onSelect: (propertyValue: PersonPropertyValue[]) => void
}

const PersonsList = ({ propertyValues, onSelect }: Props) => {
  return (
    <>
      {propertyValues.map((personValue) => (
        <div className={Styles.personItemContainer} key={personValue.id}>
          <Person
            propertyValue={personValue}
            onRemove={(removedItem) => {
              onSelect(propertyValues.filter((spv) => spv.id !== removedItem.id))
            }}
          />
        </div>
      ))}
    </>
  )
}

export default PersonsList
